/**
 * Display formatting.
 *
 * The API sends every timestamp as UTC ISO-8601 with a `Z`
 * (`2026-09-01T14:00:00.000Z`) and deliberately never sends a pre-formatted or
 * local time. That is what lets the same response render correctly wherever it
 * is opened — so converting to IST is this file's job, not the server's.
 */

const IST = 'Asia/Kolkata';

const dateTime = new Intl.DateTimeFormat('en-IN', {
  timeZone: IST,
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

const dateOnly = new Intl.DateTimeFormat('en-IN', {
  timeZone: IST,
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

/** `2026-09-01T14:00:00.000Z` → `01 Sep 2026, 07:30 pm` (IST). */
export function formatIst(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return dateTime.format(d);
}

/** `2026-09-01T14:00:00.000Z` → `01 Sep 2026` (IST). */
export function formatIstDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return dateOnly.format(d);
}

const rupees = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

/** Garment prices are nullable — a garment without one shows nothing, not ₹0. */
export function formatPrice(price: number | null | undefined): string | null {
  if (price === null || price === undefined) return null;
  return rupees.format(price);
}
